import React, { PropsWithChildren } from 'react';

export function TeaserList({ children }: PropsWithChildren) {
  return <div className="teaser-list">{children}</div>;
}
